import { type QuizSetDetailsRes } from '@/api';
import { cn } from '@/utils/tailwind.util';
import { BadgeList } from './BadgeList';
import { QuizCount } from './QuizCount';
export interface QuizMetadataBarProps extends Pick<QuizSetDetailsRes, 'quizList' | 'answerRevealMode' | 'showIncorrectAnswer' | 'isAllowPass' | 'isPublic' | 'aiTutorEnabled' | 'isAiTranslationEnabled' | 'aiTranslationLanguages'> {
  /** 루트 컨테이너를 위한 선택적 className */
  className?: string;
}

/**
 * QuizMetadataBar - 퀴즈 메타데이터 표시 바
 *
 * @description
 * 퀴즈 개수 및 옵션 배지(통과 허용, 정답 표시 여부, 공개/비공개,
 * 학습 도우미, AI 번역 등)를 표시합니다.
 *
 * **Architecture**: Page First Architecture에 따라 features/quiz-metadata/ 에 위치
 */
export const QuizMetadataBar = ({
  quizList,
  showIncorrectAnswer,
  answerRevealMode,
  isAllowPass,
  isPublic,
  aiTutorEnabled,
  isAiTranslationEnabled,
  aiTranslationLanguages,
  className
}: QuizMetadataBarProps) => {
  const quizCount = quizList?.length || 0;
  return <div className={cn('flex flex-col items-start justify-center px-[4px]', className)} data-sentry-component="QuizMetadataBar" data-sentry-source-file="QuizMetadataBar.tsx">
      <QuizCount quizCount={quizCount} data-sentry-element="QuizCount" data-sentry-source-file="QuizMetadataBar.tsx" />
      <div className="flex w-full flex-col items-start rounded-sm tablet-lg:flex-row tablet-lg:flex-wrap tablet-lg:items-center tablet-lg:gap-x-[2px] tablet-lg:gap-y-0">
        <BadgeList isAllowPass={isAllowPass} showIncorrectAnswer={showIncorrectAnswer} answerRevealMode={answerRevealMode} isPublic={isPublic} aiTutorEnabled={aiTutorEnabled} isAiTranslationEnabled={isAiTranslationEnabled} aiTranslationLanguages={aiTranslationLanguages} data-sentry-element="BadgeList" data-sentry-source-file="QuizMetadataBar.tsx" />
      </div>
    </div>;
};